import {
  CustomerListSuccess,
  CustomerDetailsSuccess,
  CustomerUnitDetailsSuccess,
} from '../../actionTypes/customerManagementAction';

const inititalState = {
  customerManagementList: [],
  customerDetails: {},
  customerUnitDetails: {},
};

export const customerManagementReducer = (state = inititalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CustomerListSuccess:
      return {
        ...state,
        customerManagementList: payload,
      };

    case CustomerDetailsSuccess:
      return {
        ...state,
        customerDetails: payload,
      };

    case CustomerUnitDetailsSuccess:
      return {
        ...state,
        customerUnitDetails: payload,
      };
    default:
      return state;
  }
};
